import { NgModule, Optional, SkipSelf } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { SharedModule } from '@shared/shared.module';
import { MaterialModule } from '../material/material.module';
import { throwIfAlreadyLoaded } from '@core/guards/module-import.guard';
import { AppComponent } from '../app.component';
import { environment } from '@environments/environment';
import { InMemoryDataService } from '@core/services/in-memory-data-service/in-memory-data.service';
import { LayoutPageComponent } from '@core/pages/layout-page.component';
import { HttpInterceptorProviders } from '@core/http-interceptors';
import { LayoutToolbarComponent } from './components/layout-toolbar/layout-toolbar.component';
import { LayoutSidenavContainerComponent } from './components/layout-sidenav-container/layout-sidenav-container.component';
import { LayoutLoginBottomSheetComponent } from './components/layout-login-bottom-sheet/layout-login-bottom-sheet.component';
import { LayoutLoginDialogComponent } from './components/layout-login-dialog/layout-login-dialog.component';
import { UpdateDialogComponent } from './components/update-dialog/update-dialog.component';
import { ThemeSwitcherComponent } from './components/theme-switcher/theme-switcher.component';
import { UnderConstructionPageComponent } from './pages/under-construction-page.component';
import { UnderConstructionComponent } from './components/under-construction/under-construction.component';
import { NotFoundPageComponent } from './pages/not-found-page.component';

import { NotFoundComponent } from './components/not-found/not-found.component';
import { AuthorizationDeniedPageComponent } from './pages/authorization-denied-page.component';
import { AuthorizationDeniedComponent } from './components/authorization-denied/authorization-denied.component';
import { LayoutSignalRDialogComponent } from './components/layout-signalr-dialog/layout-signalr-dialog.component';
import { SwitchTenantComponent } from './components/switch-tenant/switch-tenant.component';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        HttpClientModule,
        SharedModule,
        MaterialModule,
        MatExpansionModule,
        environment.inMemory
            ? HttpClientInMemoryWebApiModule.forRoot(InMemoryDataService, { delay: environment.inMemoryDelay, post204: false, put204: false })
            : []
    ],
    providers: [HttpInterceptorProviders],
    declarations: [
        AppComponent,
        LayoutPageComponent,
        LayoutToolbarComponent,
        LayoutSidenavContainerComponent,
        LayoutLoginBottomSheetComponent,
        LayoutLoginDialogComponent,
        LayoutSignalRDialogComponent,
        UpdateDialogComponent,
        ThemeSwitcherComponent,
        UnderConstructionPageComponent,
        UnderConstructionComponent,
        NotFoundPageComponent,
        NotFoundComponent,
        AuthorizationDeniedPageComponent,
        AuthorizationDeniedComponent,
        SwitchTenantComponent
    ]
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
